import { FunctionComponent } from 'react';

type LiveIconProps = {
  width?: number | string;
  height?: number | string;
  active?: boolean;
  disable?: boolean;
};

const LiveIcon: FunctionComponent<LiveIconProps> = ({
  width = 34,
  height = 34,
  active = false,
  disable = false,
}) => {
  const circleFill = active ? '#561BDC' : disable ? '#D5D5D5' : '#FAFAFA';
  const strokeColor = active ? '#EDEDED' : disable ? '#8E8E8E' : '#1A1A1A';

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 34 34"
    >
      <g transform="translate(-820 -1050)">
        <circle
          cx="17"
          cy="17"
          r="17"
          transform="translate(820 1050)"
          fill={circleFill}
        />
        <g transform="translate(10013.182 150.182)">
          <path
            d="M115.007,195.7a10.6,10.6,0,0,0,5.451-7.564"
            transform="translate(-9285.184 730.94)"
            fill="none"
            stroke={strokeColor}
            strokeWidth="1.2"
          />
          <path
            d="M88.458,195.7a10.6,10.6,0,0,1-5.451-7.564"
            transform="translate(-9270.639 730.94)"
            fill="none"
            stroke={strokeColor}
            strokeWidth="1.2"
          />
          <path
            d="M104.852,163.27a10.968,10.968,0,0,0-10.245,0"
            transform="translate(-9275.912 742.818)"
            fill="none"
            stroke={strokeColor}
            strokeWidth="1.2"
          />
          <path
            d="M115.818,176c-1.718,0-3.818,1.151-3.818,1.939v1.879a7.228,7.228,0,0,0,7.636,0v-1.879C119.636,177.151,117.536,176,115.818,176Z"
            transform="translate(-9283.818 736.455)"
            fill="none"
            stroke={strokeColor}
            strokeWidth="1.2"
          />
          <path
            d="M117.182,166A2.132,2.132,0,0,0,115,167.964v1.526a2.194,2.194,0,0,0,4.364,0v-1.526A2.132,2.132,0,0,0,117.182,166Z"
            transform="translate(-9285.182 741)"
            fill="none"
            stroke={strokeColor}
            strokeWidth="1.2"
          />
          <path
            d="M100.818,197C99.1,197,97,198.152,97,198.939v1.879a7.228,7.228,0,0,0,7.636,0v-1.879C104.636,198.152,102.536,197,100.818,197Z"
            transform="translate(-9276.999 726.909)"
            fill="none"
            stroke={strokeColor}
            strokeWidth="1.2"
          />
          <path
            d="M102.182,187A2.132,2.132,0,0,0,100,188.964v1.526a2.194,2.194,0,0,0,4.364,0v-1.526A2.132,2.132,0,0,0,102.182,187Z"
            transform="translate(-9278.364 731.455)"
            fill="none"
            stroke={strokeColor}
            strokeWidth="1.2"
          />
          <path
            d="M85.818,176C84.1,176,82,177.151,82,177.939v1.879a7.228,7.228,0,0,0,7.636,0v-1.879C89.636,177.151,87.536,176,85.818,176Z"
            transform="translate(-9270.182 736.455)"
            fill="none"
            stroke={strokeColor}
            strokeWidth="1.2"
          />
          <path
            d="M87.182,166A2.132,2.132,0,0,0,85,167.964v1.526a2.194,2.194,0,0,0,4.364,0v-1.526A2.132,2.132,0,0,0,87.182,166Z"
            transform="translate(-9271.546 741)"
            fill="none"
            stroke={strokeColor}
            strokeWidth="1.2"
          />
        </g>
      </g>
    </svg>
  );
};

export default LiveIcon;
